import React from "react";

import { Link, LinkProps, To } from "react-router-dom";
import { ReactSVG } from "react-svg";

type IconPosition = "left" | "right";

type IconLinkProps = {
  src: string;
  text: string;
  to?: To;
  href?: string;
  iconPosition?: IconPosition;
  download?: boolean;
};
export const IconLink = ({
  src,
  to,
  href,
  text,
  iconPosition = "left",
  ...rest
}: Omit<LinkProps, "to"> & IconLinkProps) => {
  const contents = (
    <>
      {iconPosition === "left" && <ReactSVG src={src} />}
      <span className="b3">{text}</span>
      {iconPosition === "right" && <ReactSVG src={src} />}
    </>
  );

  if (href) {
    return (
      <a {...rest} href={href} className="d-flex gap-2">
        {contents}
      </a>
    );
  }

  return (
    <Link to={to || ""} {...rest} className="d-flex gap-2">
      {contents}
    </Link>
  );
};
